
import isEmpty from 'lodash/isEmpty'

import Tags from '@product/components/Tags'

import { SEO_TAGS_DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from '../../Landing.constants'

import translations from './ProductTags.translations'

export default {
  components: {
    Tags,
  },
  props: {
    tags: { type: Array, required: true },
  },
  computed: {
    emptyTags() {
      return isEmpty(this.tags)
    },
    dataSelectorAttribute() {
      return SEO_TAGS_DATA_SELECTOR_ATTRIBUTE_FOR_SEO
    },
    translations: () => translations,
  },
}
